export const icons = {
  DRUGS: 'DRUGS',
  HOME: 'HOME',
  MENU: 'MENU',
  MENU_ARROW: 'MENU_ARROW',
  MENU_R_ARROW: 'MENU_R_ARROW',
  MENU_L_ARROW: 'MENU_L_ARROW',
  SHARE: 'SHARE',
  PIE: 'PIE',
  UNITS: 'UNITS',
  USERS: 'USERS',
  HELP: 'HELP',
  MAIL: 'MAIL',
  RECAL: 'RECAL',
  BLOCK: 'BLOCK',
  ERROR_MESSAGES: 'ERROR_MESSAGES',
  PORTAL: 'PORTAL',
  SETTINGS: 'SETTINGS',
  DIRECTION: 'DIRECTION',
  CHECK: 'CHECK',
  CROSS: 'CROSS',
  SEARCH: 'SEARCH',
  MENU2: 'MENU2',
  PLUS: 'PLUS',
  MENU_D_ARROW: 'MENU_D_ARROW',
  QUESTION: 'QUESTION',
  LANGUAGE: 'LANGUAGE',
  LOGOUT: 'LOGOUT',
  STACK: 'STACK',
  MONITOR: 'MONITOR',
  ATTENTION: 'ATTENTION',
  SUCCESS: 'SUCCESS',
  NO_CONNECTION: 'NO_CONNECTION',
  LIGHT_CHECK: 'LIGHT_CHECK',
  WHITE_CROSS: 'WHITE_CROSS',
  WHITE_CHECK: 'WHITE_CHECK',
  PASSWORD: 'PASSWORD',
  USER: 'USER',
  CSV: 'CSV',
  EDIT: 'EDIT',
  DUPLICATE: 'DUPLICATE',
  MAX: 'MAX',
  ESTABLISHMENT: 'ESTABLISHMENT',
  MORE: 'MORE',
  SWITCH: 'SWITCH',
  RESET_PASS: 'RESET_PASS',
  HISTORY: 'HISTORY',
  DEMAND_AND_OFFER: 'DEMAND_AND_OFFER',
  REPORT: 'REPORT',
  EXPAND: 'EXPAND',
  SEND: 'SEND',
  REJECT: 'REJECT',
  RETURN: 'RETURN',
  DOWNLOAD: 'DOWNLOAD',
  ERROR: 'ERROR',
  PROGRESS: 'PROGRESS',
  RESOLVE: 'RESOLVE',
  UPLOAD: 'UPLOAD',
  OPERATIONS: 'OPERATIONS',
  PACKAGES: 'PACKAGES',
  ANNOUNCEMENTS: 'ANNOUNCEMENTS',
  DOCS: 'DOCS',
  DOCS_FLIPPED: 'DOCS_FLIPPED',
  Calendar: 'Calendar',
  Chat: 'Chat',
  Supply: 'Supply',
  ExclamationCircle: 'ExclamationCircle',
  RobotOutlined: 'RobotOutlined',
  LIGHTBULB: 'LIGHTBULB'
};
